<template>
  <div>
    <h1 class="text-h1 mb-16">You're logged into a different account</h1>
    <p class="pb-16 text-body text-grey-body">Your employer-sponsored Premium access is associated with:</p>
    <p v-if="maskedMemberEmail" class="pb-16 text-body text-grey-body">
      <strong>{{ maskedMemberEmail }}</strong>
    </p>
    <p class="pb-16 text-body text-grey-body">Please log out and log back in with this email to continue.</p>
    <Button class="w-full" variant="primary" value="Log out" size="medium" href="/logout" />
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';

export default {
  name: 'VerifyCorporateUpgradeWrongAccount',
  components: {
    Button,
  },
  props: {
    maskedMemberEmail: {
      type: String,
      default: '',
    },
  },
};
</script>
